/// <amd-module name="Release/DeletedPipelines/DeletedPipelines" />

import * as React from "react";

import { IVssComponentContext, VssComponent, css } from "VSS/Platform/Layout";
import { IVssHistoryService } from "VSS/Platform/History";

import { Table, ITableColumn, ITableRowDetails, TableRow, ITableRow, TableCell } from "VSSUI/Table";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { IListSelection, ListSelection } from "VSSUI/List";

import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { StoreManager } from "DistributedTask/Flux/StoreManager";

import { Actions as DeletedPipelinesActions } from "./Actions";
import { DeletedPipelinesActionCreator } from "./ActionCreator";
import { IDeletedPipelinesListState, DeletedPipelinesStore } from "./Store";
import { IDeletedDefinitionReference } from "./DeletedPipelinesData";

import * as Resources from "Release/DeletedPipelines/Resources";

export class DeletePipelines extends VssComponent<{}, IDeletedPipelinesListState>  {
    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const historyService = context.pageContext.getService<IVssHistoryService>("IVssHistoryService");
        const historyState = historyService.getState();
        delete historyState["_a"];
        delete historyState.definitionId;
        delete historyState.path;
        historyService.replaceState(historyState);

        this._actionCreator = ActionCreatorManager.GetActionCreator<DeletedPipelinesActionCreator>(DeletedPipelinesActionCreator);
        this._store = StoreManager.GetStore<DeletedPipelinesStore>(DeletedPipelinesStore);
        this._actionCreator.fetchDeletedPipelines(context.pageContext);

        this.state = this._store.getState();
        this._store.addChangedListener(this._onUpdate);
    }

    public componentWillUnmount(): void {
        this._store.removeChangedListener(this._onUpdate);
    }

    public render(): React.ReactNode {

        if (!this._selection) {
            this._selection = new ListSelection();
            this._selection.select(0);
        }

        return this.state.isLoading ?
            (<Spinner className={"flex flex-center"} size={SpinnerSize.large} />)
            : (this.state.pipelines.length) ?
                (<div className={"absolute-fill"}>
                    <Table
                        className={"deleted-pipe-list"}
                        pageSize={30}
                        itemProvider={new ArrayItemProvider(this._store.getState().pipelines)}
                        columns={[{ id: "delete-pipeline-column", width: -100, renderCell: this._renderCell }]}
                        selection={this._selection}
                        showLines={false}
                        singleClickActivation={true}
                        onActivate={(event, tableRow: ITableRow<IDeletedDefinitionReference>) => ActionsHubManager.GetActionsHub<DeletedPipelinesActions>(DeletedPipelinesActions).selectPipeline.invoke(tableRow.data)}
                    />
                </div>)
                : (<div className="no-del-pipe">{Resources.NoDeletedPipelines}</div>);
    }

    private _onUpdate = () => {
        const state = this._store.getState();
        this.setState(state);
    };

    private _renderCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IDeletedDefinitionReference>, tableItem: IDeletedDefinitionReference): JSX.Element => {
        return (
            <TableCell
                className={"del-pipe-cell"}
                key={"pipe-" + tableItem.id}
                columnIndex={columnIndex}
                tableColumn={tableColumn}>

                <div className={"flex flex-grow name fontWeightSemiBold fontSizeM"}>{tableItem.name}</div>
                <div className={"flex flex-grow path"}>{tableItem.path || ""}</div>

            </TableCell >);
    }

    private _selection: IListSelection;
    private _actionCreator: DeletedPipelinesActionCreator;
    private _store: DeletedPipelinesStore;
}

export function getDeletedPipelinesView(): React.ReactNode {
    return (
        <DeletePipelines />
    );
}